import { sanitizeTextWithOnlyNumbers } from './sanitize';

const allCountries = [
  {
    code: 'AF',
    name: 'Afeganistão',
    ddd: '+93',
  },
  {
    code: 'AL',
    name: 'Albânia',
    ddd: '+355',
  },
  {
    code: 'DZ',
    name: 'Algéria',
    ddd: '+213',
  },
  {
    code: 'AS',
    name: 'Samoa Americana',
    ddd: '+1684',
  },
  {
    code: 'AD',
    name: 'Andorra',
    ddd: '+376',
  },
  {
    code: 'AO',
    name: 'Angola',
    ddd: '+244',
  },
  {
    code: 'AI',
    name: 'Anguilla',
    ddd: '+1264',
  },
  {
    code: 'AG',
    name: 'Antigua e Barbuda',
    ddd: '+1268',
  },
  {
    code: 'AR',
    name: 'Argentina',
    ddd: '+54',
  },
  {
    code: 'AM',
    name: 'Armênia',
    ddd: '+374',
  },
  {
    code: 'AW',
    name: 'Aruba',
    ddd: '+297',
  },
  {
    code: 'AU',
    name: 'Austrália',
    ddd: '+61',
  },
  {
    code: 'AT',
    name: 'Áustria',
    ddd: '+43',
  },
  {
    code: 'AZ',
    name: 'Azerbaijão',
    ddd: '+994',
  },
  {
    code: 'BS',
    name: 'Bahamas',
    ddd: '+1242',
  },
  {
    code: 'BH',
    name: 'Bahrein',
    ddd: '+973',
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    ddd: '+880',
  },
  {
    code: 'BB',
    name: 'Barbados',
    ddd: '+246',
  },
  {
    code: 'BY',
    name: 'Bielorrússia',
    ddd: '+375',
  },
  {
    code: 'BE',
    name: 'Bélgica',
    ddd: '+32',
  },
  {
    code: 'BZ',
    name: 'Belize',
    ddd: '+501',
  },
  {
    code: 'BJ',
    name: 'Benin',
    ddd: '+229',
  },
  {
    code: 'BM',
    name: 'Bermuda',
    ddd: '+1441',
  },
  {
    code: 'BT',
    name: 'Butão',
    ddd: '+975',
  },
  {
    code: 'BO',
    name: 'Bolívia',
    ddd: '+591',
  },
  {
    code: 'BA',
    name: 'Bósnia e Herzegovina',
    ddd: '+387',
  },
  {
    code: 'BW',
    name: 'Botswana',
    ddd: '+267',
  },
  {
    code: 'BR',
    name: 'Brasil',
    ddd: '+55',
  },
  {
    code: 'IO',
    name: 'Território Britânico do Oceano Índico',
    ddd: '+246',
  },
  {
    code: 'BG',
    name: 'Bulgária',
    ddd: '+359',
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
    ddd: '+226',
  },
  {
    code: 'BI',
    name: 'Burundi',
    ddd: '+257',
  },
  {
    code: 'KH',
    name: 'Camboja',
    ddd: '+855',
  },
  {
    code: 'CM',
    name: 'Camarões',
    ddd: '+237',
  },
  {
    code: 'CA',
    name: 'Canadá',
    ddd: '+1',
  },
  {
    code: 'CV',
    name: 'Cabo Verde',
    ddd: '+238',
  },
  {
    code: 'KY',
    name: 'Ilhas Cayman',
    ddd: '+1345',
  },
  {
    code: 'CF',
    name: 'República Centro-Africana',
    ddd: '+236',
  },
  {
    code: 'TD',
    name: 'Chade',
    ddd: '+235',
  },
  {
    code: 'CL',
    name: 'Chile',
    ddd: '+56',
  },
  {
    code: 'CN',
    name: 'China',
    ddd: '+86',
  },
  {
    code: 'CO',
    name: 'Colômbia',
    ddd: '+57',
  },
  {
    code: 'KM',
    name: 'Comores',
    ddd: '+269',
  },
  {
    code: 'CG',
    name: 'Congo',
    ddd: '+242',
  },
  {
    code: 'CD',
    name: 'Congo (DR)',
    ddd: '+242',
  },
  {
    code: 'CK',
    name: 'Ilhas Cook',
    ddd: '+682',
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    ddd: '+506',
  },
  {
    code: 'CI',
    name: 'Costa do Marfim',
    ddd: '+225',
  },
  {
    code: 'HR',
    name: 'Croácia',
    ddd: '+385',
  },
  {
    code: 'CU',
    name: 'Cuba',
    ddd: '+53',
  },
  {
    code: 'CW',
    name: 'Curaçao',
    ddd: '+599',
  },
  {
    code: 'CY',
    name: 'Chipre',
    ddd: '+357',
  },
  {
    code: 'CZ',
    name: 'República Tcheca',
    ddd: '+420',
  },
  {
    code: 'DK',
    name: 'Dinamarca',
    ddd: '+45',
  },
  {
    code: 'DJ',
    name: 'Djibuti',
    ddd: '+253',
  },
  {
    code: 'DM',
    name: 'Dominica',
    ddd: '+1767',
  },
  {
    code: 'DO',
    name: 'República Dominicana',
    ddd: '+1809',
  },
  {
    code: 'EC',
    name: 'Equador',
    ddd: '+593',
  },
  {
    code: 'EG',
    name: 'Egito',
    ddd: '+20',
  },
  {
    code: 'SV',
    name: 'El Salvador',
    ddd: '+503',
  },
  {
    code: 'GQ',
    name: 'Guiné Equatorial',
    ddd: '+240',
  },
  {
    code: 'ER',
    name: 'Eritreia',
    ddd: '+291',
  },
  {
    code: 'EE',
    name: 'Estônia',
    ddd: '+372',
  },
  {
    code: 'ET',
    name: 'Etiópia',
    ddd: '+251',
  },
  {
    code: 'FK',
    name: 'Ilhas Malvinas',
    ddd: '+500',
  },
  {
    code: 'FO',
    name: 'Ilhas Faroe',
    ddd: '+298',
  },
  {
    code: 'FJ',
    name: 'Fiji',
    ddd: '+679',
  },
  {
    code: 'FI',
    name: 'Finlândia',
    ddd: '+358',
  },
  {
    code: 'FR',
    name: 'França',
    ddd: '+33',
  },
  {
    code: 'PF',
    name: 'Polinésia Francesa',
    ddd: '+689',
  },
  {
    code: 'GA',
    name: 'Gabão',
    ddd: '+241',
  },
  {
    code: 'GM',
    name: 'Gâmbia',
    ddd: '+220',
  },
  {
    code: 'GE',
    name: 'Geórgia',
    ddd: '+995',
  },
  {
    code: 'DE',
    name: 'Alemanha',
    ddd: '+49',
  },
  {
    code: 'GH',
    name: 'Gana',
    ddd: '+233',
  },
  {
    code: 'GI',
    name: 'Gibraltar',
    ddd: '+350',
  },
  {
    code: 'GR',
    name: 'Grécia',
    ddd: '+30',
  },
  {
    code: 'GL',
    name: 'Groelândia',
    ddd: '+299',
  },
  {
    code: 'GD',
    name: 'Granada',
    ddd: '+1473',
  },
  {
    code: 'GU',
    name: 'Guão',
    ddd: '+1671',
  },
  {
    code: 'GT',
    name: 'Guatemala',
    ddd: '+502',
  },
  {
    code: 'GG',
    name: 'Guernsey',
    ddd: '+44',
  },
  {
    code: 'GN',
    name: 'Guiné',
    ddd: '+224',
  },
  {
    code: 'GW',
    name: 'Guiné-Bissau',
    ddd: '+245',
  },
  {
    code: 'HT',
    name: 'Haiti',
    ddd: '+509',
  },
  {
    code: 'HN',
    name: 'Honduras',
    ddd: '+504',
  },
  {
    code: 'HK',
    name: 'Hong Kong',
    ddd: '+852',
  },
  {
    code: 'HU',
    name: 'Hungria',
    ddd: '+36',
  },
  {
    code: 'IS',
    name: 'Islândia',
    ddd: '+354',
  },
  {
    code: 'IN',
    name: 'Índia',
    ddd: '+91',
  },
  {
    code: 'ID',
    name: 'Indonésia',
    ddd: '+62',
  },
  {
    code: 'IR',
    name: 'Iran',
    ddd: '+98',
  },
  {
    code: 'IQ',
    name: 'Iraque',
    ddd: '+964',
  },
  {
    code: 'IE',
    name: 'Irlanda',
    ddd: '+353',
  },
  {
    code: 'IM',
    name: 'Ilha de Man',
    ddd: '+44',
  },
  {
    code: 'IL',
    name: 'Israel',
    ddd: '+972',
  },
  {
    code: 'IT',
    name: 'Itália',
    ddd: '+39',
  },
  {
    code: 'JM',
    name: 'Jamaica',
    ddd: '+1876',
  },
  {
    code: 'JP',
    name: 'Japão',
    ddd: '+81',
  },
  {
    code: 'JE',
    name: 'Jersey',
    ddd: '+44',
  },
  {
    code: 'JO',
    name: 'Jordânia',
    ddd: '+962',
  },
  {
    code: 'KZ',
    name: 'Cazaquistão',
    ddd: '+7',
  },
  {
    code: 'KE',
    name: 'Quênia',
    ddd: '+254',
  },
  {
    code: 'KI',
    name: 'Kiribati',
    ddd: '+686',
  },
  {
    code: 'KP',
    name: 'Coreia do Norte',
    ddd: '+850',
  },
  {
    code: 'KR',
    name: 'Coreia do Sul',
    ddd: '+82',
  },
  {
    code: 'KW',
    name: 'Kuwait',
    ddd: '+965',
  },
  {
    code: 'KG',
    name: 'Quirguistão',
    ddd: '+996',
  },
  {
    code: 'LA',
    name: 'Laos',
    ddd: '+856',
  },
  {
    code: 'LV',
    name: 'Letônia',
    ddd: '+371',
  },
  {
    code: 'LB',
    name: 'Líbano',
    ddd: '+961',
  },
  {
    code: 'LS',
    name: 'Lesoto',
    ddd: '+266',
  },
  {
    code: 'LR',
    name: 'Libéria',
    ddd: '+231',
  },
  {
    code: 'LY',
    name: 'Líbia',
    ddd: '+218',
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
    ddd: '+423',
  },
  {
    code: 'LT',
    name: 'Lituânia',
    ddd: '+370',
  },
  {
    code: 'LU',
    name: 'Luxemburgo',
    ddd: '+352',
  },
  {
    code: 'MO',
    name: 'Macao',
    ddd: '+853',
  },
  {
    code: 'MK',
    name: 'Macedônia',
    ddd: '+389',
  },
  {
    code: 'MG',
    name: 'Madagascar',
    ddd: '+261',
  },
  {
    code: 'MW',
    name: 'Malawi',
    ddd: '+265',
  },
  {
    code: 'MY',
    name: 'Malásia',
    ddd: '+60',
  },
  {
    code: 'MV',
    name: 'Maldivas',
    ddd: '+960',
  },
  {
    code: 'ML',
    name: 'Mali',
    ddd: '+223',
  },
  {
    code: 'MT',
    name: 'Malta',
    ddd: '+356',
  },
  {
    code: 'MH',
    name: 'Ilhas Marshall',
    ddd: '+692',
  },
  {
    code: 'MQ',
    name: 'Martinica',
    ddd: '+596',
  },
  {
    code: 'MR',
    name: 'Mauritânia',
    ddd: '+222',
  },
  {
    code: 'MU',
    name: 'Maurício',
    ddd: '+230',
  },
  {
    code: 'MX',
    name: 'México',
    ddd: '+52',
  },
  {
    code: 'FM',
    name: 'Micronésia',
    ddd: '+691',
  },
  {
    code: 'MD',
    name: 'Moldova',
    ddd: '+373',
  },
  {
    code: 'MC',
    name: 'Mônaco',
    ddd: '+377',
  },
  {
    code: 'MN',
    name: 'Mongólia',
    ddd: '+976',
  },
  {
    code: 'ME',
    name: 'Montenegro',
    ddd: '+382',
  },
  {
    code: 'MS',
    name: 'Montserrat',
    ddd: '+1664',
  },
  {
    code: 'MA',
    name: 'Marrocos',
    ddd: '+212',
  },
  {
    code: 'MZ',
    name: 'Moçambique',
    ddd: '+258',
  },
  {
    code: 'MM',
    name: 'Birmânia',
    ddd: '+95',
  },
  {
    code: 'NA',
    name: 'Namíbia',
    ddd: '+264',
  },
  {
    code: 'NR',
    name: 'Nauru',
    ddd: '+674',
  },
  {
    code: 'NP',
    name: 'Nepal',
    ddd: '+977',
  },
  {
    code: 'NL',
    name: 'Holanda',
    ddd: '+31',
  },
  {
    code: 'NZ',
    name: 'Nova Zelândia',
    ddd: '+64',
  },
  {
    code: 'NI',
    name: 'Nicarágua',
    ddd: '+505',
  },
  {
    code: 'NE',
    name: 'Niger',
    ddd: '+227',
  },
  {
    code: 'NG',
    name: 'Nigéria',
    ddd: '+234',
  },
  {
    code: 'NU',
    name: 'Niue',
    ddd: '+683',
  },
  {
    code: 'NF',
    name: 'Ilha Norfolk',
    ddd: '+672',
  },
  {
    code: 'MP',
    name: 'Ilhas Marianas do Norte',
    ddd: '+1670',
  },
  {
    code: 'NO',
    name: 'Noruega',
    ddd: '+47',
  },
  {
    code: 'OM',
    name: 'Omã',
    ddd: '+968',
  },
  {
    code: 'PK',
    name: 'Paquistão',
    ddd: '+92',
  },
  {
    code: 'PW',
    name: 'Palau',
    ddd: '+680',
  },
  {
    code: 'PS',
    name: 'Palestina',
    ddd: '+970',
  },
  {
    code: 'PA',
    name: 'Panamá',
    ddd: '+507',
  },
  {
    code: 'PG',
    name: 'Papua-Nova Guiné',
    ddd: '+675',
  },
  {
    code: 'PY',
    name: 'Paraguai',
    ddd: '+595',
  },
  {
    code: 'PE',
    name: 'Peru',
    ddd: '+51',
  },
  {
    code: 'PH',
    name: 'Filipinas',
    ddd: '+63',
  },
  {
    code: 'PN',
    name: 'Ilhas Picárnia',
    ddd: '+672',
  },
  {
    code: 'PL',
    name: 'Polônia',
    ddd: '+48',
  },
  {
    code: 'PT',
    name: 'Portugal',
    ddd: '+351',
  },
  {
    code: 'PR',
    name: 'Porto Rico',
    ddd: '+1787',
  },
  {
    code: 'QA',
    name: 'Catar',
    ddd: '+974',
  },
  {
    code: 'RO',
    name: 'Romênia',
    ddd: '+40',
  },
  {
    code: 'RU',
    name: 'Rússia',
    ddd: '+70',
  },
  {
    code: 'RW',
    name: 'Ruanda',
    ddd: '+250',
  },
  {
    code: 'KN',
    name: 'São Cristóvão',
    ddd: '+1869',
  },
  {
    code: 'LC',
    name: 'Santa Lúcia',
    ddd: '+1758',
  },
  {
    code: 'WS',
    name: 'Samoa',
    ddd: '+684',
  },
  {
    code: 'SM',
    name: 'São Marino',
    ddd: '+378',
  },
  {
    code: 'ST',
    name: 'Sao Tomé e Príncipe',
    ddd: '+239',
  },
  {
    code: 'SA',
    name: 'Arábia Saudita',
    ddd: '+966',
  },
  {
    code: 'SN',
    name: 'Senegal',
    ddd: '+221',
  },
  {
    code: 'RS',
    name: 'Sérvia',
    ddd: '+381',
  },
  {
    code: 'SC',
    name: 'Seicheles',
    ddd: '+248',
  },
  {
    code: 'SL',
    name: 'República da Serra Leoa',
    ddd: '+232',
  },
  {
    code: 'SG',
    name: 'Singapura',
    ddd: '+65',
  },
  {
    code: 'SX',
    name: 'São Martinho',
    ddd: '+599',
  },
  {
    code: 'SK',
    name: 'Eslováquia',
    ddd: '+421',
  },
  {
    code: 'SI',
    name: 'Eslovênia',
    ddd: '+386',
  },
  {
    code: 'SB',
    name: 'Ilhas Salomão',
    ddd: '+677',
  },
  {
    code: 'SO',
    name: 'Somália',
    ddd: '+252',
  },
  {
    code: 'ZA',
    name: 'África do Sul',
    ddd: '+27',
  },
  {
    code: 'SS',
    name: 'Sudão do Sul',
    ddd: '+211',
  },
  {
    code: 'ES',
    name: 'Espanha',
    ddd: '+34',
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
    ddd: '+94',
  },
  {
    code: 'SD',
    name: 'Sudão',
    ddd: '+249',
  },
  {
    code: 'SR',
    name: 'Suriname',
    ddd: '+597',
  },
  {
    code: 'SZ',
    name: 'Suazilândia',
    ddd: '+268',
  },
  {
    code: 'SE',
    name: 'Suécia',
    ddd: '+46',
  },
  {
    code: 'CH',
    name: 'Suiça',
    ddd: '+41',
  },
  {
    code: 'SY',
    name: 'Síria',
    ddd: '+963',
  },
  {
    code: 'TW',
    name: 'Taiwan',
    ddd: '+886',
  },
  {
    code: 'TJ',
    name: 'Tajiquistão',
    ddd: '+992',
  },
  {
    code: 'TZ',
    name: 'Tanzânia',
    ddd: '+255',
  },
  {
    code: 'TH',
    name: 'Tailândia',
    ddd: '+66',
  },
  {
    code: 'TG',
    name: 'Togo',
    ddd: '+228',
  },
  {
    code: 'TK',
    name: 'Toquelau',
    ddd: '+690',
  },
  {
    code: 'TO',
    name: 'Tonga',
    ddd: '+676',
  },
  {
    code: 'TT',
    name: 'Trinidad e Tobago',
    ddd: '+1868',
  },
  {
    code: 'TN',
    name: 'Tunísia',
    ddd: '+216',
  },
  {
    code: 'TR',
    name: 'Turquia',
    ddd: '+90',
  },
  {
    code: 'TM',
    name: 'Turcomenistão',
    ddd: '+7370',
  },
  {
    code: 'TC',
    name: 'Ilhas Turks e Caicos',
    ddd: '+1649',
  },
  {
    code: 'TV',
    name: 'Tuvalu',
    ddd: '+688',
  },
  {
    code: 'UG',
    name: 'Uganda',
    ddd: '+256',
  },
  {
    code: 'UA',
    name: 'Ucrânia',
    ddd: '+380',
  },
  {
    code: 'AE',
    name: 'Emirados Árabes',
    ddd: '+971',
  },
  {
    code: 'GB',
    name: 'Reino Unido',
    ddd: '+44',
  },
  {
    code: 'US',
    name: 'Estados Unidos',
    ddd: '+1',
  },
  {
    code: 'UY',
    name: 'Uruguai',
    ddd: '+598',
  },
  {
    code: 'UZ',
    name: 'Uzbequistão',
    ddd: '+998',
  },
  {
    code: 'VU',
    name: 'Vanuatu',
    ddd: '+678',
  },
  {
    code: 'VE',
    name: 'Venezuela',
    ddd: '+58',
  },
  {
    code: 'VN',
    name: 'Vietnam',
    ddd: '+84',
  },
  {
    code: 'VI',
    name: 'Ilhas Virgens (USA)',
    ddd: '+1340',
  },
  {
    code: 'YE',
    name: 'Iêmen',
    ddd: '+967',
  },
  {
    code: 'ZM',
    name: 'Zâmbia',
    ddd: '+260',
  },
  {
    code: 'ZW',
    name: 'Zimbábue',
    ddd: '+263',
  },
];

export const allCountriesWithCustomLabel = allCountries.reduce(
  (countries, country) => ({ ...countries, [country.code]: country.ddd }),
  {},
);

export function getCountryCode(code) {
  const foundCountry = allCountries.find((country) => country.code === code);

  return sanitizeTextWithOnlyNumbers(foundCountry?.ddd);
}

export const DEFAULT_COUNTRY = 'BR';
